import React, {FC} from 'react';

import iconStateSuccess from "assets/icons/commons/source-state-active.svg"

interface DataSourceProps {
  label: string
}

export const LabelOnly: FC<DataSourceProps> = ({
  label,
}) => {

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
    >
      <div className="flex max-h-11 rounded items-center">
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
            <img src={iconStateSuccess} className="mr-2" />
            {label}
          </div>
        </div>
        <div className="flex mr-auto">
        </div>
        <div>
        </div>
      </div>
    </div>
  );
};
